interface LeadingLineFigureProps {
  size?: number;
}

/// Top-down view of a vessel approaching a harbour entrance along
/// a charted leading line. Front + rear marks aligned at the
/// charted bearing; shoal water shaded on either side; an
/// inset shows what the helmsman SEES (rear mark rising above the
/// front, both lined up vertically).
export function LeadingLineFigure({ size = 360 }: LeadingLineFigureProps) {
  return (
    <svg
      viewBox="0 0 420 320"
      width={size}
      style={{ display: "block", maxWidth: "100%", height: "auto" }}
      role="img"
      aria-label="Top-down view of a leading line. Front and rear beacons mark a safe channel; the vessel steers to keep them aligned."
    >
      {/* Deep water everywhere */}
      <rect x="0" y="0" width="420" height="320" fill="#dde7ef" />

      {/* Shoal water on both sides of the channel */}
      <path
        d="M 0 0 L 0 320 L 120 320 L 150 220 L 165 140 L 175 60 L 175 0 Z"
        fill="#caa86b"
        opacity="0.55"
        stroke="#a8895a"
        strokeWidth="0.6"
      />
      <path
        d="M 420 0 L 420 320 L 300 320 L 270 220 L 255 140 L 245 60 L 245 0 Z"
        fill="#caa86b"
        opacity="0.55"
        stroke="#a8895a"
        strokeWidth="0.6"
      />

      {/* Solid land at the top */}
      <path
        d="M 175 0 L 245 0 L 245 50 L 175 50 Z"
        fill="#caa86b"
        stroke="#7d6a44"
        strokeWidth="0.6"
      />

      {/* Leading line — heavy dashed line down the centre of the
          channel; arrowhead at the seaward end so we know it's the
          approach direction. */}
      <line
        x1="210"
        y1="60"
        x2="210"
        y2="290"
        stroke="#1e6091"
        strokeWidth="1.6"
        strokeDasharray="6 4"
      />
      <polygon points="206,290 214,290 210,300" fill="#1e6091" />

      {/* Front mark (closer to the water, lower) — triangle */}
      <polygon
        points="210,70 218,84 202,84"
        fill="#c0382b"
        stroke="#1c2530"
        strokeWidth="0.8"
      />
      <text
        x="220"
        y="78"
        fontSize="10"
        fill="#0f172a"
        fontWeight="600"
        fontFamily="ui-sans-serif, system-ui"
      >
        Front mark (lower)
      </text>

      {/* Rear mark (further inland, higher) — taller triangle */}
      <polygon
        points="210,18 222,42 198,42"
        fill="#c0382b"
        stroke="#1c2530"
        strokeWidth="0.8"
      />
      <text
        x="225"
        y="32"
        fontSize="10"
        fill="#0f172a"
        fontWeight="600"
        fontFamily="ui-sans-serif, system-ui"
      >
        Rear mark (higher)
      </text>

      {/* Charted leading bearing label */}
      <text
        x="180"
        y="170"
        fontSize="11"
        fill="#1e6091"
        fontWeight="600"
        fontFamily="ui-sans-serif, system-ui"
        transform="rotate(-90 180 170)"
      >
        Leading line — bearing 003°
      </text>

      {/* Vessel on the line, approaching */}
      <g transform="translate(210 250) rotate(0)">
        <polygon
          points="0,-8 5,6 -5,6"
          fill="#1c2530"
          stroke="#0f172a"
          strokeWidth="0.6"
        />
        <line x1="0" y1="-8" x2="0" y2="-18" stroke="#0f172a" strokeWidth="1.2" />
      </g>

      {/* Shoal labels */}
      <text
        x="90"
        y="180"
        fontSize="10"
        fill="#7d6a44"
        fontStyle="italic"
        fontFamily="ui-sans-serif, system-ui"
      >
        shoal
      </text>
      <text
        x="320"
        y="180"
        fontSize="10"
        fill="#7d6a44"
        fontStyle="italic"
        fontFamily="ui-sans-serif, system-ui"
      >
        shoal
      </text>
    </svg>
  );
}
